export default class FilterSelection {
    constructor($el) {
        this.el = $el;
        this.results = $el.querySelector('.filter-selection__results');
        this.inputs = $el.querySelectorAll('input, select');

        this.initInputs();
    };

    createFilterButton({
        label, 
        colourHex, 
        colourHexBorder
    }) {
        const button = document.createElement('button');
        const buttonCloseIcon = document.createElement('div');
        const buttonContent = document.createElement('div');
        const buttonContentText = document.createTextNode(label);

        button.className = 'filter-selection__results-btn';
        buttonCloseIcon.className = 'filter-selection__results-btn-icon';

        buttonContent.appendChild(buttonContentText);
        button.appendChild(buttonCloseIcon);
        button.appendChild(buttonContent);

        if (colourHex) {
            const buttonColour = document.createElement('div');

            buttonColour.className = 'filter-selection__results-btn-colour';
            buttonColour.style.backgroundColor = colourHex;

            if (colourHexBorder) {
                buttonColour.classList.add(`filter-selection__results-btn-colour--border-${colourHexBorder}`);
            }

            button.appendChild(buttonColour);
        }

        return button;
    }

    setupInputButtons() {
        if (!this.results) return;

        this.results.innerHTML = '';
        this.el.classList.remove('filter-selection--active');

        this.inputs.forEach($input => {
            if ($input.nodeName === 'INPUT') {
                const { label, colourHex, colourHexBorder } = $input.dataset;

                const button = this.createFilterButton({
                    label, 
                    colourHex, 
                    colourHexBorder
                });

                button.addEventListener('click', () => {
                    $input.checked = false;
                    $input.dispatchEvent(new Event('change'));
                });

                if ($input?.checked) {
                    this.results.insertAdjacentElement('beforeend', button);

                    this.el.classList.add('filter-selection--active');
                }
            }

            if ($input.nodeName === 'SELECT' && $input?.options) {
                Array.from($input.options).forEach($option => {
                    const { label, colourHex, colourHexBorder } = $option.dataset;

                    const button = this.createFilterButton({
                        label, 
                        colourHex, 
                        colourHexBorder
                    });

                    button.addEventListener('click', () => {
                        $option.selected = false;
                        $input.dispatchEvent(new Event('change'));
                    });

                    if ($option?.selected) {
                        this.results.insertAdjacentElement('beforeend', button);

                        this.el.classList.add('filter-selection--active');
                    }
                });
            }
        });
    }

    initInputs() {
        if (!this.inputs || !this.results) return;

        this.setupInputButtons();

        this.inputs.forEach($input => {
            $input.addEventListener('change', () => {
                this.setupInputButtons();
            });
        });
    }
}
